import React, { useState } from "react";
import {
  Box,
  Card,
  CardMedia,
  CardContent,
  IconButton,
  Typography,
  Menu,
  Grid,
} from "@mui/material";
import { PlayArrow, Pause, Favorite, MoreVert } from "@mui/icons-material";
import Navbar from "../component/Navbar";
import BottomBar from "../component/BottomBar";
import { useAudio } from "../component/AudioProvider";

const Home = () => {
  const {
    tracks,
    isPlayingIndex,
    playTrack,
    pauseTrack,
    toggleFavorite,
    audioRef,
  } = useAudio();

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedTrack, setSelectedTrack] = useState(null);

  const handlePlayPause = (index) => {
    if (isPlayingIndex === index) {
      pauseTrack();
    } else {
      playTrack(index);
    }
  };

  const handleFavorite = (index) => {
    toggleFavorite(index);
  };

  const handleMenuOpen = (event, track) => {
    setAnchorEl(event.currentTarget);
    setSelectedTrack(track);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedTrack(null);
  };

  const handleNext = () => {
    if (isPlayingIndex === null || tracks.length === 0) return;
    const nextIndex = (isPlayingIndex + 1) % tracks.length;
    playTrack(nextIndex);
  };

  const handlePrev = () => {
    if (isPlayingIndex === null || tracks.length === 0) return;
    const prevIndex = (isPlayingIndex - 1 + tracks.length) % tracks.length;
    playTrack(prevIndex);
  };

  if (!tracks.length) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "90vh",
        }}
      >
        <Typography variant="h6">Loading songs...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ height: "100vh" }}>
      <Navbar />
      <Grid
        container
        spacing={2}
        sx={{ padding: 2, marginBottom: 7, overflowY: "scroll", height: "90vh" }}
      >
        {tracks.map((track, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={index}>
            <Card
              sx={{
                backgroundColor: "#1E1E1E",
                color: "#F9FAFB",
                borderRadius: 3,
                boxShadow: 3,
                width: "250px",
                height: 280,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <CardMedia
                component="img"
                image={track.imageUrl}
                alt={track.title}
                sx={{
                  height: 180,
                  width: "100%",
                  objectFit: "cover",
                  borderTopLeftRadius: 12,
                  borderTopRightRadius: 12,
                  bgcolor: "#273746",
                }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/fallback-image.jpg";
                }}
              />
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    mb: 1,
                  }}
                >
                  {track.title}
                </Typography>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <IconButton
                    onClick={() => handleFavorite(index)}
                    sx={{ color: track.liked ? "red" : "gray" }}
                  >
                    <Favorite />
                  </IconButton>
                  <IconButton onClick={() => handlePlayPause(index)} color="primary">
                    {isPlayingIndex === index ? (
                      <Pause sx={{ color: "gray", fontSize: 30 }} />
                    ) : (
                      <PlayArrow sx={{ color: "gray", fontSize: 30 }} />
                    )}
                  </IconButton>
                  <IconButton onClick={(e) => handleMenuOpen(e, track)}>
                    <MoreVert sx={{ color: "white" }} />
                  </IconButton>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
          <Typography sx={{ px: 2, pt: 1 }}>{selectedTrack?.title}</Typography>
          {/* <MenuItem onClick={handleAddToPlaylist}>Add to Playlist</MenuItem> */}
        </Menu>
      </Grid>

      <BottomBar
        audioRef={audioRef}
        track={tracks?.[isPlayingIndex] || null}
        isPlaying={isPlayingIndex !== null}
        onPlayPause={() => {
          if (isPlayingIndex !== null) {
            handlePlayPause(isPlayingIndex);
          }
        }}
        onNext={handleNext}
        onPrev={handlePrev}
      />
    </Box>
  );
};

export default Home;
